import { firstString, normalizeThoughtDetailsArray } from './thoughtDetails.js'

function assistantMetaFromFlatObject(root) {
  const meta = root.meta && typeof root.meta === 'object' ? root.meta : {}
  const thoughtSummary = firstString(root.thoughtSummary, root.thought_summary, meta.thoughtSummary)
  const thoughtDetails =
    normalizeThoughtDetailsArray(root.thoughtDetails) ?? normalizeThoughtDetailsArray(meta.thoughtDetails)
  const out = {}
  if (thoughtSummary) out.thoughtSummary = thoughtSummary
  const agentBrand = firstString(root.agentBrand, root.agent_brand, meta.agentBrand)
  const agentName = firstString(root.agentName, root.agent_name, meta.agentName)
  if (agentBrand) out.agentBrand = agentBrand
  if (agentName) out.agentName = agentName
  if (thoughtDetails) out.thoughtDetails = thoughtDetails
  return out
}

export function assistantMetaFromChatResponse(data) {
  if (!data || typeof data !== 'object') return {}
  const choiceMsg = data.choices?.[0]?.message
  const fromChoice = choiceMsg && typeof choiceMsg === 'object' ? assistantMetaFromFlatObject(choiceMsg) : {}
  return { ...fromChoice, ...assistantMetaFromFlatObject(data) }
}

export function pickAssistantMessageMetaFromResult(result) {
  if (!result?.ok) return {}
  return assistantMetaFromChatResponse(result)
}

export function normalizeBlocksFromChatResponse(data) {
  if (!data || typeof data !== 'object') return null
  if (Array.isArray(data.blocks) && data.blocks.length) return data.blocks
  const blocks = data.choices?.[0]?.message?.blocks
  return Array.isArray(blocks) && blocks.length ? blocks : null
}
